import { gql } from "@apollo/client";

// ==================== PROVIDER QUERIES ====================

export const GET_MY_PROVIDER = gql`
  query GetMyProvider {
    myProvider {
      id
      title
      tagline
      description
      avatar
      heroImage
      roles {
        role
        organization
      }
      experience {
        title
        company
        period
        description
        achievements
      }
      education {
        degree
        institution
        year
        description
      }
      skills {
        name
        level
        endorsements
      }
      expertise
      achievements
      testimonials {
        name
        location
        rating
        text
        avatar
      }
      contactInfo {
        email
        phone
        website
        linkedIn
        twitter
        instagram
        facebook
      }
      availability {
        schedule
        timezone
        notes
      }
      featuredProductIds
      status
      aboutStory
      portfolioUrl
      urlSlug
      isPublic
      isFeatured
      client {
        id
        fName
        lName
        email
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_PUBLIC_PROVIDER_BY_CLIENT = gql`
  query GetPublicProviderByClient($clientId: ID!) {
    publicProviderByClient(clientId: $clientId) {
      id
      title
      tagline
      description
      avatar
      heroImage
      roles {
        role
        organization
      }
      experience {
        title
        company
        period
        description
        achievements
      }
      education {
        degree
        institution
        year
        description
      }
      skills {
        name
        level
        endorsements
      }
      expertise
      achievements
      testimonials {
        name
        location
        rating
        text
        avatar
      }
      contactInfo {
        email
        phone
        website
        linkedIn
        twitter
        instagram
        facebook
      }
      availability {
        schedule
        timezone
        notes
      }
      featuredProductIds
      status
      aboutStory
      portfolioUrl
      isPublic
      isFeatured
      client {
        id
        fName
        lName
        email
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_PUBLIC_PROVIDER_BY_SLUG = gql`
  query GetPublicProviderBySlug($urlSlug: String!) {
    publicProviderBySlug(urlSlug: $urlSlug) {
      id
      title
      tagline
      description
      avatar
      heroImage
      roles {
        role
        organization
      }
      experience {
        title
        company
        period
        description
        achievements
      }
      education {
        degree
        institution
        year
        description
      }
      skills {
        name
        level
        endorsements
      }
      expertise
      achievements
      testimonials {
        name
        location
        rating
        text
        avatar
      }
      contactInfo {
        email
        phone
        website
        linkedIn
        twitter
        instagram
        facebook
      }
      availability {
        schedule
        timezone
        notes
      }
      featuredProductIds
      status
      aboutStory
      portfolioUrl
      urlSlug
      isPublic
      isFeatured
      client {
        id
        fName
        lName
        email
      }
      createdAt
      updatedAt
    }
  }
`;

export const DISCOVER_PROVIDERS = gql`
  query DiscoverProviders($searchQuery: String, $limit: Float, $scopeToTenant: Boolean) {
    discoverProviders(searchQuery: $searchQuery, limit: $limit, scopeToTenant: $scopeToTenant) {
      id
      title
      tagline
      description
      avatar
      expertise
      achievements
      status
      isPublic
      isFeatured
      contactInfo {
        email
        website
      }
      client {
        id
        fName
        lName
      }
      createdAt
      updatedAt
    }
  }
`;

export const IS_URL_SLUG_AVAILABLE = gql`
  query IsUrlSlugAvailable($urlSlug: String!, $excludeId: ID) {
    isUrlSlugAvailable(urlSlug: $urlSlug, excludeId: $excludeId)
  }
`;

// ==================== PROVIDER MUTATIONS ====================

export const CREATE_PROVIDER = gql`
  mutation CreateProvider($input: CreateProviderInput!) {
    createProvider(input: $input) {
      id
      title
      tagline
      description
      status
      isPublic
    }
  }
`;

export const UPDATE_PROVIDER = gql`
  mutation UpdateProvider($id: ID!, $input: UpdateProviderInput!) {
    updateProvider(id: $id, input: $input) {
      id
      title
      tagline
      description
      status
      isPublic
    }
  }
`;

export const DELETE_PROVIDER = gql`
  mutation DeleteProvider($id: ID!) {
    deleteProvider(id: $id)
  }
`;

export const UPDATE_PROVIDER_STATUS = gql`
  mutation UpdateProviderStatus($id: ID!, $status: ProviderStatus!) {
    updateProviderStatus(id: $id, status: $status)
  }
`;

export const UPDATE_PROVIDER_URL_SLUG = gql`
  mutation UpdateProviderUrlSlug($id: ID!, $urlSlug: String!) {
    updateProviderUrlSlug(id: $id, urlSlug: $urlSlug)
  }
`;

// ==================== FILE UPLOAD MUTATIONS ====================

export const UPLOAD_UNENCRYPTED_FILE = gql`
  mutation UploadUnencrypted($file: Upload!) {
    uploadUnencryptedFile(file: $file)
  }
`;

// ==================== AI MUTATIONS ====================

export const IMPROVE_TEXT = gql`
  mutation ImproveText($text: String!, $type: String!, $context: String) {
    improveText(text: $text, type: $type, context: $context)
  }
`;

export const IMPROVE_TAGLINE = gql`
  mutation ImproveTagline($text: String!, $context: String) {
    improveTagline(text: $text, context: $context)
  }
`;

export const IMPROVE_DESCRIPTION = gql`
  mutation ImproveDescription($text: String!, $context: String) {
    improveDescription(text: $text, context: $context)
  }
`;

export const GENERATE_HERO_IMAGE = gql`
  mutation GenerateHeroImage($prompt: String!, $style: String) {
    generateHeroImage(prompt: $prompt, style: $style)
  }
`;
